<div class="pb-16">
  <div class="header-style">
    <div class="h-100">
      @if (authService.getUserData().type === utils.userTypes.Distributor || authService.getUserData().type === utils.userTypes.DistributorChild) {
        <mat-form-field appearance="outline" class="select">
          <mat-select 
            data-testid="usedOnMobile_filter" 
            (selectionChange)="filterChange($event.value)" 
            [(value)]="selected" 
            #usedOnMobile_filter  
            id="usedOnMobile_filter"
            name="usedOnMobile_filter"
          >
            <mat-option i18n="@@ValueProposalUsedonmobile" value="usedOnMobile">Value Proposal Used on mobile</mat-option>
            <mat-option i18n="@@ValueProposalToPickFrom" value="manufacturer">Value Proposal To Pick From</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator 
        i18n-aria-label="@@paginator"
        [length]="totalSize" 
        [pageSize]="pageSize" 
        [pageIndex]="pageNumber - 1" 
        [pageSizeOptions]="[10, 20, 50, 100]" 
        (page)="handlePage($event)"
      ></mat-paginator>

      @if (user.type !== utils.userTypes.Admin) {
        <mat-icon 
          data-testid="add_value_proposal_button" 
          (click)="addValueProposal()" 
          class="cursor add-icon" 
          svgIcon="add" 
          i18n-label="@@addValueProposal" 
          aria-label="Add Value Proposal">
        </mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input 
              i18n-placeholder="@@searchPlaceholder" 
              data-testid="departments_search_input" 
              matInput 
              formControlName="search" 
              id="search" 
              placeholder="Search" 
              name="search"
            />
            <mat-icon 
              data-testid="departments_clear_button" 
              class="cursor" 
              matSuffix 
              (click)="clearSearch()" 
              i18n-label="@@clearSearch" 
              aria-label="Clear Search">
              clear
            </mat-icon>
          </mat-form-field>
        }
      </form>

      <mat-icon 
        data-testid="departments_search_button" 
        (click)="handleSearchClick()" 
        class="cursor"  
        svgIcon="search" 
        i18n-label="@@searchButton" 
        aria-label="Search">
      </mat-icon>
    </div>
  </div>

  @for (item of departmentsList; track item; let itemIndex = $index) {
    <mat-card 
      data-testid="open_value_proposals_button" 
      (click)="openValueProposalDetails(item.id, item.name)" 
      class="simple-card cursor mat-subtitle-1"
      i18n-label="@@openDepartment" 
      aria-label="Open Value Proposals for {{item.name}}"
    >
      <mat-card-content matTooltip ellipsisTooltip>
        {{item.name}} 
      </mat-card-content>
    </mat-card>
  }

  @if (departmentsList.length === 0) {
    <img 
      class="empty-view-img" 
      src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" 
      alt="No departments available"
      i18n-alt="@@emptyDepartmentsImageAlt"
    >
  }
</div>